@for (
	course of courses();
	track track(course.id, $index);
	let isFirst = $first;
	let isLast = $last
) {
	<uc-course-card
		[isFirst]="isFirst"
		[isLast]="isLast"
		[course]="course"
		[uniSlug]="uniSlug()"
		[product]="product()"
		[uniId]="uniId()"
		[uniName]="uniName()"
		[ugSearchOrderPosition]="ugSearchOrderPosition()"
		[cleSearchOrderPosition]="null"
	>
		<uc-course-card-btns
			ctaButtons
			[uniId]="uniId()"
			[uniName]="uniName()"
			[isFeatured]="isFeatured()"
			[externalUrl]="externalUrl()"
			[product]="product()"
			[courseId]="course.id"
			[courseName]="course.name"
			[courseSlug]="course.slug"
			[isCourseSaved]="course.saved"
			[ugSearchOrderPosition]="ugSearchOrderPosition()"
			[academicYear]="course.year"
		/>
	</uc-course-card>
}
